var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#525D70","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M2 8h.007M2 12h.007M2 4h.007m3.326 4H14m-8.667 4H14M5.333 4H14"}})])
}
var staticRenderFns = []

export default { render: render }